import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Progress, Icon, Popover, Tooltip } from 'antd'
import moment from 'moment'
import { connect } from 'react-redux'

import {
    Avatar,
    InfoWrapper,
    Title,
    CreatedAt,
    ProjectInfo,
    MoreActionWrapper,
} from './BoardListCard.style'

import { IconSvg } from '../../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import MoreIcon from '../../../../assets/images/icon/16.svg'
import PrivateIcon from '../../../../assets/images/icon/18.svg'
import PublicIcon from '../../../../assets/images/icon/19.svg'
import PlusIcon from '../../../../assets/images/icon/24.svg'
import SoftwareIcon from '../../../../assets/images/icon/20.svg'
import scrumBoardActions from '../../../../../redux/scrumBoard/actions'

import defaultImg from '../../../../../resource/image/imgTaskDefault.jpeg'
import { Row, Col } from 'antd'

const currenttime = new Date().getTime() / 1000

function BoardListCard({
    item,
    onDelete,
    onEdit,
    makeStarForTask,
    deleteStarForTask,
}) {
    const [enableStar, setenableStar] = useState(item.star)

    const MoreActions = (
        <MoreActionWrapper>
            {/* <p onClick={onEdit}>Sửa nhiệm vụ</p> */}
            <p onClick={onDelete}>Xoá nhiệm vụ</p>
        </MoreActionWrapper>
    )
    const actionStar = () => {
        console.log('enable star', enableStar)
        if (enableStar) {
            deleteStarForTask(item.id)
        } else {
            makeStarForTask(item.id)
        }
        setenableStar(!enableStar)
    }
    console.log('item list', item)

    const GetNameStatusTask = () => {
        if (item.status === 0) {
            return 'Nhiệm vụ mới khởi tạo'
        }
        if (item.status === 1) {
            return 'Nhiệm vụ mới triển khai'
        }

        if (item.status === 3) {
            return 'Nhiệm vụ đang làm'
        }
        if (item.status === 4) {
            return 'Nhiệm vụ đã hoàn thành'
        }
        if (item.status === 5) {
            return 'Nhiệm vụ đã xoá'
        }
    }

    return (
        <Row
            style={{
                padding: 5,
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Col span={12}>
                <Link
                    to={{
                        pathname: `/app/qbtask/project/${item.id}`,
                        state: { data: item },
                    }}
                >
                    <ProjectInfo>
                        <Avatar
                            style={{ objectFit: 'cover' }}
                            src={item.avatar !== '' ? item.avatar : defaultImg}
                            alt={item.name}
                        />
                        <InfoWrapper>
                            <Title>{item.title}</Title>
                            {item.deadline - currenttime <= 0 &&
                                item.status !== 4 && (
                                    <Tooltip
                                        title="Nhiệm vụ đã quá hạn"
                                        placement="bottom"
                                        key={item.deadline}
                                    >
                                        <CreatedAt
                                            style={{
                                                justifycontent: 'center',
                                                borderRadius: 3,
                                                backgroundColor: 'red',
                                                color: 'white',
                                            }}
                                        >
                                            <Icon
                                                type="clock-circle"
                                                style={{
                                                    paddingRight: 5,
                                                    paddingLeft: 3,
                                                }}
                                            />
                                            {moment(
                                                item.created_at * 1000
                                            ).format('DD/MM/YYYY')}
                                        </CreatedAt>
                                    </Tooltip>
                                )}
                            {item.deadline - currenttime <= 259200 &&
                                item.deadline - currenttime > 0 &&
                                item.status !== 4 && (
                                    <Tooltip
                                        title="Nhiệm vụ sắp đến hạn kết thúc"
                                        placement="bottom"
                                        key={item.deadline}
                                    >
                                        <CreatedAt
                                            style={{
                                                justifycontent: 'center',
                                                borderRadius: 3,
                                                backgroundColor: '#f2d600',
                                                color: 'white',
                                            }}
                                        >
                                            <Icon
                                                type="clock-circle"
                                                style={{
                                                    paddingRight: 5,
                                                    paddingLeft: 3,
                                                }}
                                            />
                                            {moment(
                                                item.deadline * 1000
                                            ).format('DD/MM/YYYY')}
                                        </CreatedAt>
                                    </Tooltip>
                                )}
                            {item.deadline - currenttime > 259200 &&
                                item.status !== 4 && (
                                    <CreatedAt style={{ color: '#eaebed' }}>
                                        <Icon
                                            type="clock-circle"
                                            style={{
                                                paddingRight: 5,
                                                paddingLeft: 3,
                                                color: '#eaebed',
                                            }}
                                        />
                                        {moment(item.deadline * 1000).format(
                                            'DD/MM/YYYY'
                                        )}
                                    </CreatedAt>
                                )}
                            {item.status === 4 && (
                                <CreatedAt style={{ color: '#eaebed' }}>
                                    <Icon
                                        type="clock-circle"
                                        style={{
                                            paddingRight: 5,
                                            paddingLeft: 3,
                                            color: '#eaebed',
                                        }}
                                    />
                                    {moment(item.deadline * 1000).format(
                                        'DD/MM/YYYY'
                                    )}
                                </CreatedAt>
                            )}
                        </InfoWrapper>
                    </ProjectInfo>
                </Link>
            </Col>
            <Col span={4}>
                <div
                    style={{
                        width: 150,
                        paddingLeft: 20,
                        alignItems: 'center',
                        color: '#eaebed',
                        fontSize: 13,
                        flexDirection: 'row',
                        display: 'flex',
                    }}
                >
                    <Progress
                        strokeColor="#eaebed"
                        percent={parseInt(item.process)}
                        size="small"
                        showInfo={false}
                        status="active"
                    />
                    <text style={{ paddingLeft: 5 }}> {item.process}%</text>
                </div>
            </Col>
            <Col span={4} style={{ color: '#eaebed' }}>
                {GetNameStatusTask()}
            </Col>

            <Col span={3} style={{ color: '#eaebed' }}>
                <Icon
                    type="star"
                    theme="filled"
                    onClick={() => actionStar()}
                    style={{
                        color: enableStar ? '#ED8A19' : '#999999',
                        fontSize: 19,
                        verticalAlign: 'middle',
                        marginRight: 10,
                        cursor: 'pointer',
                    }}
                />
                Quan tâm
            </Col>

            <Col span={1}>
                <Popover
                    placement="bottom"
                    content={MoreActions}
                    trigger="click"
                >
                    <IconSvg src={MoreIcon} border={'none'} padding={'0'} />
                </Popover>
            </Col>
        </Row>
    )
}
export default connect(
    null,
    {
        ...scrumBoardActions,
    }
)(BoardListCard)
